import React, { useCallback, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import moment from "moment";
import { AnnouncementsIcon, DatePickerIconUserEvents, LikeIcon, NewBackArrowIconEventPage, NewNextArrowIconEventPage, RewardPointsIcon } from '../../utils/icons';
import { Container, Layout, SliderContainer, CompanyCard, ReservedButton, OuterCardContainer, WolibaThursdayCard} from './styles';
import PropTypes from "prop-types";
import LazyImage from "../common/LazyImage/LazyImage";
import parse from "react-html-parser";
import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { joinOrLeaveChallenge } from "../../redux/actions/userProfileActions";
import { attendEvent, attendEventLimitUser, fetchCompanyEvents } from "../../redux/actions/eventActions";
import { ImageUrl } from "../../utils/constants";
import AddInCalendar from "../../components/AddInCalendar/calendarPopup";
import { showSuccessToast } from "./ToastHelper";
import SkeletonLoder from "../common/skeletonLoder";
import { commaSeperator, convertDateInTimezone, convertMonthFromDate, fetchApi } from "../../utils/methods";
import Spinner from "../common/Spinner";
import Timer from "../EventDetails/timer";
import { toast } from "react-toastify";
import { JoinOrLeaveThemeEvent } from "../../redux/constants/apiConstants";
import MonthlyGoalChallengePopup from "./MonthlyGoalChallengePopup";
import MonthlyGoalProgress from "./MonthlyGoalProgress";

const CommonSliderSection = ({
  title = "Announcements",
  data = [],
  cardRender,
  showArrows = true,
  showDots = true,
  myAnnouncementCard = false,
  myActicityCard = false,
  myFocusCard = false,
  onInitiativeClick,
  refreshAnnouncements = () => { },
  activeFocusKey = '',
  loading = true,
  icon = <AnnouncementsIcon />,
  likeAffirmation
}) => {

  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const history = useHistory();
  const dispatch = useDispatch();

  const [showCalendar, setShowCalendar] = useState(false);
  const [eventId, setEventId] = useState(null);
  const [eventName, setEventName] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [timeout, setTimeoutState] = useState(false);
  const [selectedChallengeId, setSelectedChallengeId] = useState(null);
  // const [widthFix, setWidthFix] = useState(false);
  const [selectedActivityType, setSelectedActivityType] = useState(null);
  const [loadingJoinThemeEvent, setLoadingJoinThemeEvent] = useState(false);
  const [goalChallengePopup, setGoalChallengePopup] = useState(false);

  const today = moment();
  const endOfMonth = moment().endOf("month");
  const remainingDays = endOfMonth.diff(today, "days");

  window.console.log("", eventName)

  // useEffect(() => {
  //   window.setTimeout(() => setWidthFix(true), 100);
  // }, []);

  const joinOrLeave = data?.is_joined === 1 ? 0 : 1;

  const handleBeforeChange = (_, newIndex) => {
    setCurrentSlide(newIndex + 1);
  };

  const redirectionToDetailsPage = (data) => {
    if (data?.card_type === "challenge") {
      history.push({ pathname: `/challenges/${data?.id}`, state: { fromDashboard: true } });
    } else if (data?.card_type === "event") {
      history.push({ pathname: `/events/${data?.id}`, state: { fromDashboard: true } });
    } else if (data?.card_type === "survey") {
      history.push({ pathname: "/survey", state: { surveyId: data?.id } });
    } else if (data?.card_type === "fitness_video" && (activeFocusKey === "mindfulMonday" || activeFocusKey === "wolibaWednesday" || activeFocusKey === 'toneUpTuesday' || activeFocusKey === 'stretchSaturday')) {
      history.push(`/education/videos-library/${data?.id}`)
    } else if (data?.card_type === "recipe" && activeFocusKey === "foodieFriday") {
      history.push(`/wellness-resources/recipe-details/${data?.id}`)
    } else if (data?.card_type === "wellness_journey" && activeFocusKey === "StillnessSunday") {
      history.push(`/wellness-resources/article-details/${data?.id}`)
    }
  }

  const displayCalendarPopup = (id, title, event) => {
    event.stopPropagation();
    setShowCalendar((prev) => !prev);
    setEventId(id);
    setEventName(title);
  };

  const calendarConfirmPopup = () => {
    setTimeoutState(true);
  };

  useEffect(() => {
    if (timeout) {
      const timer = window.setTimeout(() => {
        setTimeoutState(false);
      }, 5000);
      return () => window.clearTimeout(timer);
    }
  }, [timeout]);

  const showCalendarData = (id) => {
    setShowCalendar((prev) => !prev);
    setEventId(id);
    if (typeof refreshAnnouncements === "function") {
      refreshAnnouncements();
    }
  };

  const handleGoalChallenge = (id, activityType) => {
    setSelectedChallengeId(id);
    setSelectedActivityType(activityType);
    setGoalChallengePopup(true);
  }

  const CloseGoalChallenge = () => {
    setGoalChallengePopup(false);
  }

  const hideCalendar = (id) => {
    setShowCalendar((prev) => !prev);
    setEventId(id);
    dispatch(attendEvent(id, 0, 1));
    calendarConfirmPopup();
    if (typeof refreshAnnouncements === "function") {
      refreshAnnouncements();
    }
  };

  const showHideCalendarLogic = useCallback(() => {
    setShowCalendar((prev) => ({
      showCalendar: !prev.showCalendar,
    }));
  }, []);

  const SuccessToast = () => {
    showSuccessToast("Challenge Joined!", "You can view your challenge in my activities tab");
  }

  const joinChallenge = (challengeId, isJoined, event) => {
    event.stopPropagation();
    const data = {
      challenge_id: challengeId,
      is_joined: isJoined,
    };

    // dispatch(joinOrLeaveChallenge(data));
    // this.setState({ isButtonDisabled: true });
    // window.setTimeout(() => {
    //   this.setState({ isButtonDisabled: false });
    // }, 2000);

    dispatch(joinOrLeaveChallenge(data, SuccessToast))
      .then(() => {
        refreshAnnouncements();
      });
  };

  const SuccessToastEvent = () => {
    showSuccessToast("Event Joined!", "You can view your event in my activities tab");
  }

  const joinEvent = async (eventId, event) => {
    event.stopPropagation();
    setLoadingJoinThemeEvent(true);
    const payload = {
      event_id: eventId,
      join_status: 1,
    };
    try {
      const res = await fetchApi(JoinOrLeaveThemeEvent, "POST", payload);
      if (res.status === "success") {
        SuccessToastEvent();
        // toast.success(res?.message);
        dispatch(fetchCompanyEvents());
        refreshAnnouncements();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoadingJoinThemeEvent(false);
    }
  };

  const showCalendarAndReserve = useCallback(
    (id, isAttending, title, event) => {
      event.stopPropagation();
      if (isAttending !== 1) {
        setShowCalendar((prev) => !prev);
      }
      setEventId(id);
      setEventName(title);
      setIsButtonDisabled(true);
      dispatch(attendEventLimitUser(id, isAttending, showHideCalendarLogic, SuccessToastEvent))

      // .then(() => {
      // // After Redux action completes → call parent API
      //   refreshAnnouncements();
      // });
      window.setTimeout(() => {
        setIsButtonDisabled(false);
      }, 2000);
    },
    [dispatch, showHideCalendarLogic]
  );

  const sliderSettings = {
    dots: showDots,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    adaptiveHeight: false,
    variableWidth: false,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: { dots: showDots, infinite: false, slidesToShow: 1, arrows: true },
      },
      {
        breakpoint: 600,
        settings: { dots: showDots, infinite: false, slidesToShow: 1, arrows: true },
      },
    ],
  };

  if (loading) {
    return (
      <SkeletonLoder
        width={"1248px"}
        height={"450px"}
      />
    )
  }

  return (
    <OuterCardContainer isOuterpadding={data.length > 1 ? "0px 20px 46px 20px" : "0px 20px 20px 20px"}>
      <Layout margin="20px 0 0 0" padding="0px">
        <div className="headingMain">
          <div style={{ gap: "12px" }} className="heading">
            {/* <AnnouncementsIcon /> */}
            {icon}
            {title}
          </div>

          {showArrows && data.length > 1 && (
            <div className="arrows">
              {currentSlide > 1 ? (
                <div className="iconBackground" onClick={() => sliderRef.current?.slickPrev()}>
                  {NewBackArrowIconEventPage("#DA6C74")}
                </div>
              ) : null}
              <div className="text">
                {currentSlide}/{data.length}
              </div>
              {currentSlide < data.length ? (
                <div className="iconBackground" onClick={() => sliderRef.current?.slickNext()}>
                  {NewNextArrowIconEventPage("#DA6C74")}
                </div>
              ) : <div className="iconPlaceholder"></div>}
            </div>
          )}
        </div>

        <Container>
          <SliderContainer display="flex" content="center" marginValue="0">
            <Slider {...sliderSettings} ref={sliderRef}>
              {data.map((item, index) =>
                cardRender ? (
                  cardRender(item, index)
                ) : activeFocusKey === "thankfulThursday" ? (
                  <WolibaThursdayCard color={item?.affirmation?.color_code}>
                    <div className='image-container'>
                      <LazyImage div={'image-container'} src={ImageUrl + "/" + item?.affirmation?.web_card_path} style={{ height: '275px', borderRadius: '7px' }} />
                      <span className="affirmation-text">{item?.affirmation?.text}</span>
                    </div>
                    <div className="bottom-container">
                      <div className="likes-container">
                        <div className="like-icon">
                          <LikeIcon fill={item?.likes?.is_liked ? "#DA6C74" : "none"} onClick={() => likeAffirmation({ daily_affirmation_id: item?.daily_affirmation_id, is_liked: !item?.likes?.is_liked })} />
                        </div>
                        <div className="likes-count">{item?.likes?.count} {item?.likes?.count > 1 ? 'likes' : 'like'}</div>
                      </div>
                      <span className="affirmation-bottom-text">Daily Affirmations : {item?.pillar?.title}</span>
                    </div>
                  </WolibaThursdayCard>
                ) : (
                  <div className="card" key={index}>
                    <CompanyCard
                      detailsCardPadding="20px"
                      onClick={() => item?.card_type !== 'health_initiative' && redirectionToDetailsPage(item)}
                      isCursorPointer={item?.card_type === "monthly_goal_challenge" || item?.card_type === "health_initiative" ? "default" : "pointer"}
                    >
                      <LazyImage
                        className="imageCardUserDashboard"
                        src={`${ImageUrl}/${item?.card_type === 'health_initiative' ? item?.thumbnail : (item?.image || item?.recipe_image)}`}
                        alt={item?.card_type === 'health_initiative' ? item?.name : "event"}
                        onError={(e) => { e.currentTarget.src = `${ImageUrl}/initiative-thumbnails/default.png`; }}
                      />

                      <div className="detailsCard">

                        {/* title row */}
                        {item?.card_type === 'health_initiative' ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                            {/* <div style={{ background: item?.color, borderRadius: '50%', width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                              <img
                                style={{ width: 24, height: 24 }}
                                src={`${ImageUrl}/${item?.initiative_white_icon}`}
                                alt={item?.name}
                                onError={(e) => { e.currentTarget.src = `${ImageUrl}/default-initiative.png`; }}
                              />
                            </div> */}
                            <div className="title" style={{ marginBottom: 0 }}>{item?.name}</div>
                          </div>
                        ) : (
                          <div className="title">{item?.card_type === "recipe" ? item?.name : item?.title}</div>
                        )}

                        {/* description row — ✅ use item?.about for health_initiative */}
                        {myFocusCard ? (
                          <div className="details">{parse(item?.description)}</div>
                        ) : item?.card_type === 'health_initiative' ? (
                          item?.about ? <div className="details">{parse(item?.about)}</div> : null
                        ) : (
                          <div className="details">{parse(item?.body || item?.description || item?.descriptions)}</div>
                        )}

                        {/* date row */}
                        {myActicityCard || myAnnouncementCard ? (
                          <div className="date">
                            <div className="iconV1">
                              <DatePickerIconUserEvents />
                            </div>
                            <div className="detail">
                              <div className="challengeDetails">
                                {myActicityCard && item?.card_type === "monthly_goal_challenge" ? (
                                  `${remainingDays} days remaining`
                                ) : (
                                  moment(convertDateInTimezone(item?.start_date)._d).format("YYYY") ===
                                    moment(convertDateInTimezone(item?.end_date)._d).format("YYYY")
                                    ? `${convertMonthFromDate(
                                      moment(convertDateInTimezone(item?.start_date)._d).format("MMMM D")
                                    )} - ${convertMonthFromDate(
                                      moment(convertDateInTimezone(item?.end_date)._d).format("MMMM D, YYYY")
                                    )}`
                                    : `${convertMonthFromDate(
                                      moment(convertDateInTimezone(item?.start_date)._d).format("MMMM D, YYYY")
                                    )} - ${convertMonthFromDate(
                                      moment(convertDateInTimezone(item?.end_date)._d).format("MMMM D, YYYY")
                                    )}`
                                )}
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {item?.card_type === "monthly_goal_challenge" && myActicityCard ? (
                          <MonthlyGoalProgress item={item} />
                        ) : null}

                        {/* points row */}
                        {item?.card_type === "event" ? (
                          item?.event_points && item?.event_points !== "0" ? (
                            <div className="date">
                              <div className="iconV1"><RewardPointsIcon /></div>
                              <div className="detail">
                                +{item?.event_points} {item?.event_points > 1 ? "experience points" : "experience point"}
                              </div>
                            </div>
                          ) : null
                        ) : item?.card_type === "monthly_goal_challenge" && myAnnouncementCard ? (
                          <div className="date">
                            <div className="iconV1"><RewardPointsIcon /></div>
                            <div className="detail">
                              {item?.reward_points_per_unit} XP per {commaSeperator(item?.points_per_activity_unit)} {item?.activity_type}
                            </div>
                          </div>
                        ) : item?.points && item?.points !== "0" ? (
                          <div className="date">
                            <div className="iconV1"><RewardPointsIcon /></div>
                            <div className="detail">
                              +{item?.points} {item?.card_type === "health_initiative" ? "health and wellness points" : item?.points > 1 ? "experience points" : "experience point"}
                            </div>
                          </div>
                        ) : null}


                        {/* button row */}
                        {myAnnouncementCard ? (
                          <div className="buttonContainer">
                            {item?.card_type === "health_initiative" ? (
                              <ReservedButton
                                active={1}
                                onClick={() => onInitiativeClick && onInitiativeClick(item)}
                              >
                                Complete Initiative
                              </ReservedButton>
                            ) : item?.card_type === "event" && item?.event_type !== "theme" ? (
                              <ReservedButton
                                active={1}
                                onClick={isButtonDisabled ? null : (event) => showCalendarAndReserve(item.id, item.is_joined, item.title, event)}
                              >Reserve Spot</ReservedButton>
                            ) : item?.card_type === "event" && item?.event_type === "theme" ? (
                              moment(convertDateInTimezone(item.start_date)._d) < new Date() && !item?.is_joined ?
                                <ReservedButton active={true} height="40px" style={{ marginTop: "auto" }}
                                  onClick={(event) => { !loadingJoinThemeEvent && joinEvent(item?.id, event); event.stopPropagation(); }}>
                                  {loadingJoinThemeEvent ? <Spinner color={'white'} /> : 'Join Event'}
                                </ReservedButton>
                                : moment(convertDateInTimezone(item?.start_date)._d) > new Date()
                                  ? <Timer isBackgroundColor={"#FCF2F3"} data={moment(convertDateInTimezone(item?.start_date)._d)} />
                                  : null
                            ) : item?.card_type === "challenge" ? (
                              <ReservedButton
                                active={1}
                                onClick={(event) => joinChallenge(item.id, joinOrLeave, event)}
                              >Join Challenge</ReservedButton>
                            ) : item?.card_type === "monthly_goal_challenge" ? (
                              <ReservedButton
                                active={1}
                                onClick={() => handleGoalChallenge(item.id, item?.activity_type)}
                              >Join Challenge</ReservedButton>
                            ) : (
                              <ReservedButton
                                active={1}
                                onClick={() => history.push({ pathname: "/survey", state: { surveyId: item?.id } })}
                              >Start Survey</ReservedButton>
                            )}
                          </div>
                        ) : myActicityCard ? (
                          <div className="buttonContainer">
                            {item?.card_type === "event" && item?.event_type !== "theme" ? (
                              <div className="subContainer">
                                <ReservedButton
                                  active={1}
                                  onClick={(event) => displayCalendarPopup(item.id, item.title, event)}
                                >Add to Calendar</ReservedButton>
                                <ReservedButton active={0} onClick={() => history.push({ pathname: `/events/${item?.id}`, state: { fromDashboard: true } })}>View Event</ReservedButton>
                              </div>
                            ) : (item?.card_type === "event" && item?.event_type === "theme") ? (
                              <ReservedButton active={0} onClick={() => history.push({ pathname: `/events/${item?.id}`, state: { fromDashboard: true } })}>View Event</ReservedButton>
                            ) : item?.card_type === "monthly_goal_challenge" ? (
                              <ReservedButton
                                active={1}
                                onClick={() => history.push({ pathname: `/challenges/monthly-goal-challenge/${item?.id}`, state: { fromDashboard: true } })}>
                                View Challenge
                              </ReservedButton>
                            ) : (
                              <ReservedButton
                                active={1}
                                onClick={() => history.push({ pathname: `/challenges/${item?.id}`, state: { fromDashboard: true } })}>
                                View Challenge
                              </ReservedButton>
                            )}
                          </div>
                        ) : myFocusCard ? (
                          <div className="buttonContainer">
                            {item?.card_type === "fitness_video" && (activeFocusKey === "mindfulMonday" || activeFocusKey === 'toneUpTuesday' || activeFocusKey === 'stretchSaturday') ? (
                              <ReservedButton active={1} onClick={() => history.push(`/education/videos-library/${item?.id}`)}>
                                {activeFocusKey === 'toneUpTuesday' || activeFocusKey === 'stretchSaturday' ? 'Start Exercise' : 'Start Meditation'}
                              </ReservedButton>
                            ) : item?.card_type === "fitness_video" && activeFocusKey === "wolibaWednesday" ? (
                              <ReservedButton active={1} onClick={() => history.push(`/education/videos-library/${item?.id}`)}>
                                Start Workplace Workout
                              </ReservedButton>
                            ) : item?.card_type === "recipe" && activeFocusKey === "foodieFriday" ? (
                              <ReservedButton active={1} onClick={() => history.push(`/wellness-resources/recipe-details/${item?.id}`)}>
                                Start Cooking
                              </ReservedButton>
                            ) : item?.card_type === "wellness_journey" && activeFocusKey === "StillnessSunday" ? (
                              <ReservedButton active={1} onClick={() => history.push(`/education/adventure/lifestyle/article/${item?.id}`)}>
                                Start Reading
                              </ReservedButton>
                            ) : null}
                          </div>
                        ) : null}

                      </div>
                    </CompanyCard>
                    {showCalendar && eventId === item.id && (
                      <AddInCalendar
                        show={showCalendar}
                        closeModal={showCalendarData}
                        hideCalendar={hideCalendar}
                        event={item}
                        width={"100%"}
                        margin={"0%"}
                        refreshAnnouncements={refreshAnnouncements}
                      />
                    )}
                  </div>
                )
              )}
            </Slider>

            {goalChallengePopup && (
              <MonthlyGoalChallengePopup
                show={goalChallengePopup}
                setCurrentSlide={setCurrentSlide}
                onClose={CloseGoalChallenge}
                challengeId={selectedChallengeId}
                activityType={selectedActivityType}
                refreshAnnouncements={refreshAnnouncements}
              />
            )}
          </SliderContainer>
        </Container>
      </Layout>
    </OuterCardContainer>
  );
};

CommonSliderSection.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  cardRender: PropTypes.func,
  showArrows: PropTypes.bool,
  showDots: PropTypes.bool,
  myAnnouncementCard: PropTypes.bool,
  myActicityCard: PropTypes.bool,
  myFocusCard: PropTypes.bool,
  onInitiativeClick: PropTypes.func,
  refreshAnnouncements: PropTypes.func,
  activeFocusKey: PropTypes.string,
  loading: PropTypes.bool,
  icon: PropTypes.node,
  likeAffirmation: PropTypes.func
}

export default CommonSliderSection;
